var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7415 0.258459C14.9812 0.498139 15.0624 0.853932 14.9504 1.17386L10.3181 14.4091C10.1986 14.7506 9.88273 14.9845 9.52125 14.9993C9.15977 15.014 8.82591 14.8066 8.67898 14.476L6.16975 8.83025L0.523999 6.32102C0.193399 6.17409 -0.0140095 5.84023 0.000737897 5.47875C0.0154853 5.11727 0.2494 4.80142 0.590871 4.68191L13.8261 0.0495613C14.1461 -0.0624139 14.5019 0.0187793 14.7415 0.258459ZM3.27448 5.61231L7.19658 7.35547C7.3962 7.44419 7.55581 7.6038 7.64453 7.80342L9.38769 11.7255L12.6794 2.32058L3.27448 5.61231Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.d5a764bdbe6afbfa2792f5a0db4c9071.svg";
export { ForwardRef as ReactComponent };